import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import EmergencyListings from "./EmergencyListings";
import EmergencyNearbyMap from "./EmergencyNearbyMap";

interface DistrictOption {
  slug: string;
  label: string;
  icon: string;
}

const districtOptions: DistrictOption[] = [
  { slug: "", label: "All Districts", icon: "ri-map-2-line" },
  { slug: "south-canara", label: "South Canara", icon: "ri-building-4-line" },
  { slug: "udupi", label: "Udupi", icon: "ri-ancient-gate-line" },
  { slug: "north-canara", label: "North Canara", icon: "ri-sailboat-line" },
];

export default function EmergencyListingsSection() {
  const [district, setDistrict] = useState("");

  const activeLabel = district
    ? districtOptions.find((option) => option.slug === district)?.label ?? "coastal Karnataka"
    : "coastal Karnataka";

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="Near you"
          title="Hospitals, clinics & emergency care"
          description="Highly rated healthcare providers across the coast — from multispeciality hospitals to round-the-clock pharmacies and diagnostic labs."
          action={{ label: "See all healthcare listings", to: "/directory?category=healthcare" }}
        />

        <div className="mt-6 flex flex-wrap items-center gap-2">
          <span className="mr-1 inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold uppercase tracking-wider text-foreground-500">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-filter-3-line text-sm" />
            </span>
            Filter by area
          </span>
          {districtOptions.map((option) => {
            const active = district === option.slug;
            return (
              <button
                key={option.slug || "all"}
                type="button"
                onClick={() => setDistrict(option.slug)}
                aria-pressed={active}
                className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${
                  active
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className={`${option.icon} text-base`} />
                </span>
                {option.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6">
          <EmergencyNearbyMap districtSlug={district} districtLabel={activeLabel} />
        </div>

        <div className="mt-8">
          <EmergencyListings category="healthcare" district={district} pageSize={6} />
        </div>
      </div>
    </section>
  );
}